module.exports = __webpack_public_path__ + "img/img_bottom.b931c278.png";